<nav class="navbar navbar-expand-lg navbar-light bg-light navbarCustom fixed-top">
  <div class="container-fluid">
    <a class="navbar-brand" href="#"><img src="./assets/images/logo.png" style="width: 60px" /></a>
    <h3 class="header_text" style="color: white; margin-top: 10px">
      Institute for Training in Ministry (iTIM)
    </h3>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item" [ngClass]="{ active: currentRoute == '/index' }">
          <a class="nav-link" href="#">Home</a>
        </li>
        <li class="nav-item dropdown" [ngClass]="{
            active:
              currentRoute == '/about' ||
              currentRoute == '/operation-manual' ||
              currentRoute == '/statement-of-faith'
          }">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-expanded="false">About iTIM</a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" [routerLink]="['/about']">About</a>
            <a class="dropdown-item" [routerLink]="['/operation-manual']">Operations Manual</a>
            <a class="dropdown-item" routerLink="/statement-of-faith">
              Our Doctrinal Statement
            </a>

            <a class="dropdown-item" routerLink="/learning">
              Learning about iTIM from the Founder
            </a>
            <a class="dropdown-item" routerLink="/certificates">
              Certificate
            </a>
          </div>
        </li>
        



        <li *ngIf="!isauth" class="nav-item dropdown" [ngClass]="{
            active:
              currentRoute == '/session' || currentRoute == '/registration'
          }">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-expanded="false">Login</a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" [routerLink]="['/session']" >Sign in </a>
            <a class="dropdown-item" [routerLink]="['/registration']">Sign up</a>
          </div>
        </li>


        <li style="cursor: pointer;" class="nav-item" (click)="seminar()">
          <a class="nav-link">Seminar</a>
        </li>
        <li class="nav-item" [ngClass]="{ active: currentRoute == '/contact-us' }">
          <a class="nav-link" [routerLink]="['/contact-us']">Contact Us</a>
        </li>
        <li class="nav-item" [ngClass]="{ active: currentRoute == '/give' }">
          <a class="nav-link" [routerLink]="['/give']">Give</a>
        </li>
        <li *ngIf="isauth" class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-expanded="false">
            {{ username }}
          </a>
          <div class="dropdown-menu dropdown-menu-lg-right" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" data-toggle="modal" data-target="#profileModal">Profile</a>
            <a class="dropdown-item" (click)="logout()">Logout</a>
          </div>
        </li>
        <li *ngIf="isauth" class="nav-item">
          <div class="userPic">
            <img *ngIf="editModelData?.profile" src="{{ apiUrl }}{{ editModelData?.profile }}" />
          </div>
        </li>
      </ul>

    </div>
  </div>

</nav>

<!-- Modal Profile -->
<div class="modal fade" id="profileModal" tabindex="-1" aria-labelledby="profileModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Edit Profile</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form *ngIf="profileForm" [formGroup]="profileForm">
          <div class="form-group">
            <div class="profile-pic">
              <label class="-label" for="file">
                <span>Change Image</span>
              </label>
              <img src="{{ apiUrl }}{{ editModelData?.profile }}" id="output" width="200" *ngIf="!imageSrc" />
              <img [src]="imageSrc" id="output" width="200" *ngIf="imageSrc" />
              <input type="file" id="file" #inputFile class="form-control" (change)="onFileChange($event)"
                accept="image/*" />
            </div>
            <div *ngIf="
                submitted && (this.image == null || this.image == undefined)
              ">
              <span class="error-text text-center">Select Image</span>
            </div>
          </div>
          <div class="form-group">
            <label class="fontBlk">Name</label>
            <input type="text" class="form-control input" formControlName="firstName"
              [class.is-invalid]="isControlInvalid('firstName')" [class.is-valid]="isControlValid('firstName')" />
            <h5 class="invalid-feedback" *ngIf="controlHasError('required', 'firstName')">
              This field is required
            </h5>
          </div>
          <div class="form-group">
            <label class="fontBlk">Last Name</label>
            <input type="text" class="form-control input" formControlName="lastName"
              [class.is-invalid]="isControlInvalid('lastName')" [class.is-valid]="isControlValid('lastName')" />
            <h5 class="invalid-feedback" *ngIf="controlHasError('required', 'lastName')">
              This field is required
            </h5>
          </div>
          <!-- <div class="form-group">
            <label class="fontBlk">Password</label>
            <input type="text" class="form-control input" value="123456789">
          </div> -->
        </form>
      </div>
      <div class="modal-footer" *ngIf="profileForm">
        <button type="button" class="btn btnWhite" data-dismiss="modal">
          Cancel
        </button>
        <button *ngIf="!profileForm.valid" type="button" (click)="handleProfileSubmit()" class="btn btnPrimary">
          Save
        </button>
        <button *ngIf="profileForm.valid" type="button" (click)="handleProfileSubmit()" data-dismiss="modal"
          class="btn btnPrimary">
          Save
        </button>
      </div>
    </div>
  </div>
</div>